import { render, staticRenderFns } from "./sitelabelLife.vue?vue&type=template&id=1a8408d9&scoped=true"
import script from "./sitelabelLife.vue?vue&type=script&lang=js"
export * from "./sitelabelLife.vue?vue&type=script&lang=js"
import style0 from "./sitelabelLife.vue?vue&type=style&index=0&id=1a8408d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8408d9",
  null
  
)

export default component.exports